<template>
  <modal :show="show" @close="closeModal" :hideClose="!isSuperUser" title="Choose country for you account" class="no-overflow center-title">
    <div class="p-a-4">
      <h2 class="p-t-2 p-b-4 ta-c">
        To continue we need you to choose a country for your account.
      </h2>
      <p></p>
      <div class="d-f ai-c jc-c">
        <FormDropdown
          :items="countries"
          :search="true"
          :value="selectedCountry"
          placeholder="Select country"
          @search="searchCountry = $event"
          @input="selectedCountry = $event.value"
        />
      </div>
    </div>
    <template v-slot:footer>
      <div class="f-w ta-c">
        <Button :loading="state === 'setting'" :disabled="state === 'setting' || selectedCountry === ''" @click="setCountry">Continue</Button>
      </div>
    </template>
  </modal>
</template>

<script>

export default {
  computed: {
    /**
     * Get available countries and filter them if searching
     * @returns {Array}
     */
    countries() {
      const countries = this.accountCountries[this.$i18n.locale].map(c => ({ ...c, selected: c.value === this.selectedCountry }));

      if (this.searchCountry !== '') {
        return countries.filter(a => a.string.toLowerCase().indexOf(this.searchCountry.toLowerCase()) !== -1);
      }

      return countries;
    },
  },
  methods: {
    /**
     * Check if the account has a country selected or not
     * @returns {Void}
     */
    checkCountry() {
      // Skip showing for LVS-only accounts.. for now
      if (this.liveshoppingEnabled && !this.ppvEnabled) {
        this.show = false;
        return;
      }

      const country = this.account?.company?.address?.country;

      if (typeof country === 'undefined' || country === 'null' || country === '') {
        this.show = true;
      }
    },
    /**
     * Set country on account
     * @returns {Void}
     */
    async setCountry() {
      this.state = 'setting';

      const result = await this.$store.dispatch('AccountManager/updateAccount', {
        company: {
          address: {
            country: this.selectedCountry,
          },
        },
      });

      if (!result) {
        swal({ title: 'An error occured', text: 'For some reason we could not set a country on your account. Please try again.', icon: 'error' });
        this.state = '';
        return;
      }

      this.show = false;
    },
    /**
     * Close modal, if you are a superuser
     * @returns {Void}
     */
    closeModal() {
      if (this.isSuperUser) {
        this.show = false;
      }
    },
  },
  watch: {
    account: {
      immediate: true,
      handler(account) {
        if (!account) {
          return;
        }

        this.checkCountry();
      },
    },
  },
  data() {
    return {
      selectedCountry: '',
      searchCountry: '',
      state: '',
      show: false,
    };
  },
};
</script>
